<template>
  <div>
    <Form :model="setting"
          :rules="rules"
          :label-width="200">
      <FormItem :label="$t('pages_offline_coupon_discount_index_625')" style="max-width: 700px">
        <i-input
         v-model="setting.offline_coupon_alias_name" @on-blur="change_offline_coupon_alias_name" :placeholder="$t('pages_offline_coupon_discount_index_626')" />
      </FormItem>
    </Form>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  data () {
    return {
      rules: {
        customer_score_rate: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback()
              if (value < 0) return callback(new Error(i18n.t('pages_birthday_discount_index_210')))
              callback()
            },
          }
        ]
      }
    }
  },
  created () {
    this.display()
  },
  computed: {
    ...mapGetters('setting', ['setting']),
  },
  methods: {
    ...mapActions('setting', ['display', 'upgrade']),
    change () {
      this.upgrade({ ticket_qr_show: this.setting.ticket_qr_show })
    },
    change_offline_coupon_alias_name () {
      this.upgrade({ offline_coupon_alias_name: this.setting.offline_coupon_alias_name })
    },
  }
}
</script>
